import { COLLECT_COMPAT } from '@/api/apiModules'
import common from '@/utils/common'
export default {
  viewType: 'form',
  module: COLLECT_COMPAT,
  okAction: 'compatibleReUpload',
  params: null,
  extraParams: null,
  formatData(data) {
    data.collectType = this.extraParams.collectType
    data.collectSourceFrom = this.extraParams.collectSourceFrom
    data.collectId = this.extraParams.collectId
    data.projectId = this.extraParams.projectId
    return data
  },
  view: {
    title: '重新上报兼容性案例',
    labelPosition: 'right',
    labelWidth: '185px',
    width: '650px',
    content: [
      {
        $id: 'name',
        $type: 'input',
        label: '软件/外设名称',
        $el: {
          disabled: true
        }
      },
      {
        $id: 'versionOrType',
        $type: 'input',
        label: '软件版本号/外设类型',
        $el: {
          disabled: true
        }
      },
      {
        $id: 'compatibleList',
        $type: 'sky-product-os-compat-relate',
        label: '兼容性结论',
        $el: {}
      },
      {
        $id: 'verification',
        $type: 'upload-file',
        label: '兼容性测试文档',
        actions: {
          on: {
            updateValue: 'changeUploadAction'
          }
        },
        rules: [
          { checkFileNameLength: 200 },
          {
            customValidate: {
              validate(validateOther, form, curFormItem) {
                let validator = (rule, val, callback) => {
                  let size = val.size
                  if (size > common.fileSizeMax) {
                    callback(new Error('不能超过最大文件上传30M限制'))
                  } else {
                    callback()
                  }
                }
                return {
                  validator
                }
              }
            }
          },
          {
            suffix: {
              includeSuffixes: ['docx', 'pdf', 'zip'],
              errorMessage: '请选择docx、pdf、zip文件格式的文件进行上传'
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      }
    ]
  }
}
